import { CustomFieldSetting } from '../../../types';
import { callExternalApi } from '../../callExternalApi';

export const fetchCustomFieldSettingApi = async (accountId: string, entityType: string) => {
  const params = new URLSearchParams({ account_id: accountId, entity_type: entityType });
  return await callExternalApi<CustomFieldSetting>({
    url: `api/custom_field_setting?${params.toString()}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const updateCustomFieldSettingApi = async (
  accountId: string,
  entityType: string,
  displayOnInventory: boolean
) => {
  return await callExternalApi<CustomFieldSetting>({
    url: 'api/custom_field_setting',
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data: { account_id: accountId, entity_type: entityType, display_on_inventory: displayOnInventory }
  });
};
